<template>
	<div id="map-popup" style="height: 300px"></div>
</template>

<script>
import phonesSuccess from "@/assets/images/markers/phones_success.png";
import platForm from "@/utils/Here";
import {mapFeatures} from "@/plugins/mapFeatures";

export default {
	computed: {
		localeMap() {
			return this.$i18n.locale;
		},
	},
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		latitude: {
			type: Number,
			required: false,
			default: 51.51455,
		},
		longitude: {
			type: Number,
			required: false,
			default: -0.07306,
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		theme: {
			type: String,
			required: false,
			default: null,
		},
		calledFrom: {
			type: String,
			required: false,
			default: "maps",
		},
		cartodbId: {
			type: Number,
			default: 0,
		},
		getCallbackClick: {
			type: Function,
			default: () => {},
		},
		changeCursorEnable: {
			type: Boolean,
			default: false,
		},
		getCoordinatesDrag: {
			type: Function,
			default: () => {},
		},
	},
	data() {
		return {
			map: "",
			options: {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0,
			},
			H: window.H,
			maptypes: platForm.createDefaultLayers(),
			marker: null,
			mapFeature: null,
			behavior: null,
		};
	},
	methods: {
		success(pos) {
			const crd = pos.coords;
			const position = {cy: this.latitude || +crd.latitude, cx: this.longitude || +crd.longitude};
			if (this.calledFrom === "DinamicFields") {
				this.marker = this.mapFeature.addMarkerToMap(position, {
					icon: phonesSuccess,
					draggable: true,
					behavior: this.behavior,
					onDragend: (coords) => {
						this.getCoordinatesDrag(coords);
					},
				});
				this.$emit("getInstanceMapEmit", {map: this.map, marker: this.marker});
			}
		},
		error(err) {
			console.warn("ERROR(" + err.code + "): " + err.message);
		},
		initMap() {
			this.map = new this.H.Map(document.getElementById("map-popup"), this.maptypes.vector.normal.map, {
				zoom: 10,
				center: {lng: 150.644, lat: -34.397},
			});
			addEventListener("resize", () => this.map.getViewPort().resize());
			this.behavior = new this.H.mapevents.Behavior(new this.H.mapevents.MapEvents(this.map));
			this.H.ui.UI.createDefault(this.map, this.maptypes);
			this.map.addEventListener("tap", (event) => {
				const position = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
				this.getCallbackClick(position, this.behavior);
			});
			navigator.geolocation.getCurrentPosition(this.success, this.error, this.options);
			if (this.changeCursorEnable) {
				this.changeCursor("crosshair");
			}
			this.mapFeature = new mapFeatures(this.map);
		},
		/**
		 * TODO: change cursor options from different options
		 */
		changeCursor(type = "pointer") {
			const cursor = document.getElementById("map-popup");
			cursor.style.cursor = type;
		},
	},
	mounted() {
		this.initMap();
	},
};
</script>

<style scoped>
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 102%);
	margin-left: -35px;
	margin-right: -35px;
	height: 88vh;
}

.street-vien-container {
	width: 100%;
	height: 40vh;
}

.customizer-btn-map-opc {
	position: fixed;
	top: 50%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.customizer-btn-map-clear {
	position: fixed;
	top: 45%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition {
	position: fixed;
	top: 69px;
	left: 100px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-custom-container-calendar {
	height: 560px !important;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container {
		width: 100%;
		height: 40vh;
	}

	.map-top-left-possition {
		position: fixed;
		top: 69px;
		left: 10px;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		z-index: 50000;
	}
}
</style>
